module.exports = __webpack_public_path__ + "static/media/3.39f7e3a1.svg";